import { Chat } from "../models";
import { fetchAuthenticated } from "../scripts/custom-fetch";

export async function createChat(chat: Omit<Chat, "id" | "createdAt" | "updatedAt">) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_POST}/chats`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(chat),
  });

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as Chat;
}

export async function updateChat(chatId: number, chat: Partial<Omit<Chat, "id" | "createdAt" | "updatedAt">>) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_POST}/chats/${chatId}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(chat),
  });

  if (!response.ok) {
    throw new Error(await response.json());
  }
}

export async function getChats() {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_GET}/chats`);

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as Chat[];
}

export async function getChat(chatId: number) {
  const response = await fetchAuthenticated(`${process.env.REACT_APP_API_GET}/chats/${chatId}`);

  if (!response.ok) {
    throw new Error(await response.json());
  }

  return await response.json() as Chat;
}